import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return ["countElement"];
  }

  updateCountElement() {
    const eventValue = event.target.value;

    if (eventValue === "") {
      this.countElementTarget.innerText = 0;
    } else {
      this.countElementTarget.innerText = eventValue.split(",").length;
    }
  }
}
